import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function NotFound() {
  const navigate = useNavigate();

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1E3A5F 0%, #2E6DA4 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      p: 3,
      textAlign: 'center',
    }}>
      {/* Logo */}
      <img
        src="/torch_logo.png"
        alt="Torch"
        style={{ width: 80, height: 80, objectFit: 'contain', marginBottom: 24, opacity: 0.9 }}
      />

      {/* 404 */}
      <Typography sx={{
        fontSize: { xs: '6rem', sm: '9rem' },
        fontWeight: 900,
        color: '#C9A84C',
        lineHeight: 1,
        letterSpacing: '-4px',
        mb: 1,
      }}>
        404
      </Typography>

      <Typography variant="h5" sx={{ color: 'white', fontWeight: 700, mb: 1 }}>
        Page Not Found
      </Typography>

      <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.65)', mb: 4, maxWidth: 360 }}>
        The page you're looking for doesn't exist or may have moved.
      </Typography>

      {/* Volleyball net divider */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 4, width: '100%', maxWidth: 300 }}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Box key={i} sx={{ flex: 1, height: 2, backgroundColor: 'rgba(201,168,76,0.4)', borderRadius: 1 }} />
        ))}
      </Box>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
          sx={{
            backgroundColor: '#C9A84C',
            color: '#1E3A5F',
            fontWeight: 700,
            px: 3,
            py: 1.2,
            '&:hover': { backgroundColor: '#b8973b' },
          }}
        >
          Go Home
        </Button>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{
            borderColor: 'rgba(255,255,255,0.5)',
            color: 'white',
            fontWeight: 600,
            px: 3,
            py: 1.2,
            '&:hover': { borderColor: 'white', backgroundColor: 'rgba(255,255,255,0.1)' },
          }}
        >
          Go Back
        </Button>
      </Box>

      <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.3)', mt: 6 }}>
        Torch Beach Volleyball · app.torchvolleyball.com
      </Typography>
    </Box>
  );
}

export default NotFound;
